import { failureAction, successAction, startAction } from '../common'
import { GET_STANDING } from './types'

export const initialState = {
  loading: false,
  loaded: false,
  error: {},
  data: {},
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case startAction(GET_STANDING):
      return {
        ...state,
        loading: true,
        loaded: false,
        error: {},
        data: {},
      }
    case successAction(GET_STANDING):
      return {
        ...state,
        loading: false,
        loaded: true,
        error: {},
        data: action.payload,
      }
    case failureAction(GET_STANDING):
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.payload,
        data: {},
      }
    default:
      return state
  }
}

export default reducer
